import { gql } from "@apollo/client";

export const ONLINE_NOW_MEMBERS = gql`
  query adminOnlineNowMembers($faderLevels: [FaderLevel!]!) {
    adminOnlineNowMembers(faderLevels: $faderLevels) {
      userId
      name
      email
      zone
      faderLevel
    }
  }
`;
